import AvatarWithFallback from "@/shared/components/avatar-with-fallback/avatar-with-fallback";
import { Skeleton } from "@/shared/components/ui/skeleton";
import { formatDuration } from "@/shared/helpers/format-duration";
import { useTranslation } from "react-i18next";
export const formatNumber = (number: number) => {
  return isNaN(number) ? 0 : number.toLocaleString();
};

interface ISupplierResponse {
  contributedItemCount: number;
  email: string;
  firstName: string;
  lastName: string;
  timeSpent: number;
  userId: string;
  profilePictureUrl: string;
}
export default function SupplierTable({ users, isLoading }: { users: ISupplierResponse[], isLoading: boolean }) {
  const { i18n } = useTranslation();
  return (
    <div>
      <div className="flex items-center border-y border-[#e4e4e7] bg-[#F8FAFC] h-[36px]">
        <div className="w-[270px] px-[16px] flex-1">
          <div className="text-muted-foreground text-[14px] font-600">
            Ad Soyad
          </div>
        </div>
        <div className="w-[200px] min-[1680px]:w-[270px] min-[1800px]:w-[320px] px-[16px] text-center">
          <div className="text-muted-foreground text-[14px] font-600">
            H. Zaman
          </div>
        </div>
        <div className="w-[200px] min-[1680px]:w-[270px] min-[1800px]:w-[320px] px-[16px] text-center">
          <div className="text-muted-foreground text-[14px] font-600">
            Katkı S. Madde
          </div>
        </div>
      </div>
      <div className="h-[318px] overflow-y-auto">
        {

          users.map((item, index) => (
            <div key={item.userId + index} className="flex items-center h-[60px] ">
              <div className="w-[270px] px-[16px] flex-1">
                <div className="flex gap-[12px]">
                  <div className="">
                    <AvatarWithFallback src={item.profilePictureUrl} name={item.firstName + " " + item.lastName} alt={item.firstName + " " + item.lastName} size={40} />
                  </div>
                  <div className="flex flex-col">
                    <div className="text-[14px] font-[700] text-primary leading-[24px]">
                      {item.firstName} {item.lastName}
                    </div>
                    <div className="text-[12px] font-[500] text-muted-foreground leading-[18px]">
                      {item.email}
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-[200px] min-[1680px]:w-[270px] min-[1800px]:w-[320px] px-[16px] text-center">
                <div className="text-muted-foreground text-[14px] font-600 flex justify-center">
                  {isLoading ? <Skeleton className="w-[50px] h-[18px] mt-[4px]" /> : formatDuration(i18n.language, item.timeSpent ?? 0)}
                </div>
              </div>

              <div className="w-[200px] min-[1680px]:w-[270px] min-[1800px]:w-[320px] px-[16px] text-center">
                <div className="text-muted-foreground text-[14px] font-600 flex justify-center">
                  {isLoading ? <Skeleton className="w-[50px] h-[18px] mt-[4px]" /> : formatNumber(item.contributedItemCount)}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
